import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsEmbeddedWidgetsRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsEmbeddedWidgetsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { HelpCenterSettingsEmbeddedWidgetsAppEntryPoint } from './ui/widget-configuration/embedded-entry.tsx';
import { navigation } from './common/constants.tsx';

export const helpCenterSettingsEmbeddedWidgetsRouteEntry = createEntry(
	helpCenterSettingsEmbeddedWidgetsRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.embedded-widgets',
		layout: serviceProjectLayout,
		navigation,
		component: ErrorPagesNotFound,

		entryPoint: () => {
			return fg('csm_agent_config_widget_configuration_embed_page')
				? HelpCenterSettingsEmbeddedWidgetsAppEntryPoint
				: undefined;
		},

		resources: [...getServiceDeskSettingsResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsEmbeddedWidgetsRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsEmbeddedWidgetsRouteEntry',
			},

			enabled: true,
		},
	}),
);
